import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export function TrendBadge({ value, size = 'sm' }) {
  if (value == null || isNaN(value)) return null;
  const num = Number(value);
  const iconSize = size === 'sm' ? 10 : 14;
  const textSize = size === 'sm' ? 'text-[11px]' : 'text-xs';

  if (Math.abs(num) < 0.1) {
    return (
      <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full ${textSize} font-semibold bg-gray-100 text-gray-500`}>
        <Minus size={iconSize} /> 0.0%
      </span>
    );
  }

  const isPositive = num > 0;
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full ${textSize} font-semibold ${
      isPositive ? 'bg-emerald-50 text-emerald-600' : 'bg-red-50 text-red-600'
    }`}>
      {isPositive ? <TrendingUp size={iconSize} /> : <TrendingDown size={iconSize} />}
      {isPositive ? '+' : ''}{num.toFixed(1)}%
    </span>
  );
}
